import { configuration } from 'src/configuration';

const { accountApiUrl } = configuration;

export interface AuditActivityItem {
  eventId: string;
  timestamp: string;
  userId: string;
  email: string;
  action:
    | 'analytics_query'
    | 'notebook_cell_execution'
    | 'shared_analysis_link'
    | 'shared_notebook_link';
}

export interface AuditActivityResponse {
  items: AuditActivityItem[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export const getAuditActivity = async ({
  token,
  datasourceId,
  startDate,
  endDate,
  page,
  pageSize,
}: {
  token: string;
  datasourceId: string;
  startDate: string;
  endDate: string;
  page?: number;
  pageSize?: number;
}): Promise<AuditActivityResponse> => {
  const params = new URLSearchParams({
    datasourceId,
    startDate,
    endDate,
  });
  if (page !== undefined) params.set('page', String(page));
  if (pageSize !== undefined) params.set('pageSize', String(pageSize));

  const response = await fetch(`${accountApiUrl}/audit/activity?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  return await response.json();
};
